import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_END_SESSION_TICKET, GET_END_SESSION_TICKET_SUCCESS, GET_END_SESSION_TICKET_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getEndSessionTicket({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/tickets/feedback-selection-data`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_END_SESSION_TICKET_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_END_SESSION_TICKET_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_END_SESSION_TICKET_ERROR, payload: error });
  }
}

export function* watchGetEndSessionTicket() {
  yield takeEvery(GET_END_SESSION_TICKET, getEndSessionTicket);
}

function* getEndSessionTicketSaga() {
  yield all([fork(watchGetEndSessionTicket)]);
}

export default getEndSessionTicketSaga;